import React, { CSSProperties, useCallback } from 'react';

import { FormHoc, Input } from '../../atoms/Form';
import { PrihlasovaciUdaje, PrihlasovaciUdajeValidation, uzivatelPrihlaseni } from '../../../api';
import useApi from '../../../hooks/useApi';
import SendingContainer from '../../hoc/SendingContainer';

const STYLE: CSSProperties = {
    width: 400,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
};

function Login() {
    const { call, ...sending } = useApi<void, PrihlasovaciUdaje>({});

    const onSubmit = useCallback(
        (values: any) => {
            console.log(values);
            call(uzivatelPrihlaseni(values));
        },
        [call]
    );

    return (
        <div style={STYLE}>
            <SendingContainer {...sending}>
                <FormHoc
                    // defaultValues={{username: 'admin', password: 'Heslo123'}}
                    onSubmit={onSubmit}
                    validationSchema={PrihlasovaciUdajeValidation}>
                    {
                        ({ submitHandler }) => (
                            <form
                                onSubmit={submitHandler}
                                noValidate>
                                <Input
                                    name='username'
                                    label='Uživatel'
                                    autoFocus />
                                <Input
                                    type='password'
                                    name='password'
                                    label='Heslo' />
                                <button style={{
                                    width: '100%',
                                    padding: 15,
                                    marginTop: 10,
                                    lineHeight: 0
                                }}>
                                    přihlásit
                                </button>
                            </form>
                        )
                    }
                </FormHoc>
            </SendingContainer>
        </div>
    );
}

export default Login;
